import { cva } from "class-variance-authority";

const toastTextVariants = cva(["rounded", "border", "flex", "gap-2"], {
  variants: {
    variant: {
      default: ["border-gray-7", "text-gray-7"],
      danger: ["border-red-50", "text-red-50"],
      warn: ["border-yellow-50", "text-yellow-50"],
      success: ["border-seagreen-50", "text-seagreen-50"],
    },
    size: {
      none: "p-0 border-0 text-xs",
      default: "px-3 py-2",
      sm: "p-2 text-xs",
      md: "text-base py-2 px-3",
    },
  },
  defaultVariants: {
    variant: "default",
    size: "default",
  },
});

export { toastTextVariants };
